<template>
  <div>
    <!--跳到通栏/模块锚点-->
    <template
      v-if="sendData.linkType == 'fun'&&sendData[sendData.linkType].type  === 'jump_section'"
    >
      <anchor_link :editData="sendData[sendData.linkType][sendData[sendData.linkType].type]"></anchor_link>
    </template>
    <!--提交表单-->
    <template
      v-if="sendData.linkType == 'fun' && sendData[sendData.linkType].type  === 'submit_form'"
    >
      <div @click.stop="openEditForm" class="cover_anchor"></div>
    </template>
    <!--站内站外链接-->
    <template v-if="sendData.linkType === 'inside_link' || sendData.linkType === 'outside_link'">
      <site_link :editData="sendData"></site_link>
    </template>
    <!--电话咨询、信息咨询-->
    <template
      v-if="sendData.linkType == 'fun'
    && (sendData[sendData.linkType].type  === 'telephone_advisory'
     || sendData[sendData.linkType].type  === 'information_advisory')"
    >
      <phone_consultation :editData="sendData"></phone_consultation>
    </template>
    <!--文件下载-->
    <template
      v-if="sendData.linkType == 'fun'
     && sendData[sendData.linkType].type  === 'file_download'"
    >
      <file_download :editData="sendData"></file_download>
    </template>
    <!--弹窗视频-->
    <template
      v-if="sendData.linkType == 'fun'
     && sendData[sendData.linkType].type  === 'pop_video'"
    >
      <div class="cover_anchor" @click.stop="openVideoDialog"></div>
    </template>
  </div>
</template>

<script>
import anchor_link from "./components/anchor_link";
import customer_service from "./components/customer_service";
import file_download from "./components/file_download";
import phone_consultation from "./components/phone_consultation";
import pop_video from "./components/pop_video";
import site_link from "./components/site_link";
import submit_form from "./components/submit_form/index";
export default {
  name: "set_link_index",
  props: {
    sendData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    getForm(id, data) {
      let obj = {};
      if (id !== "") {
        for (let i = 0; i < data.length; i++) {
          if (data[i].value === id) {
            obj = data[i];
            break;
          }
        }
      }
      return obj;
    },
    openEditForm() {
      let that = this
      if(that.templet.amp_no_make()){
        return
      }
      that.templet.clickTime(() => {
          const form = that.getForm(
            that.sendData.fun.submit_form.value,
            that.$store.state.app.formList
          );
          that.$store.commit("app/set_submit_form_isShow", true);
          that.$store.commit("app/set_form", form);
      });
    },
    openVideoDialog() {
      if(this.templet.amp_no_make()){
        return
      }
      this.templet.clickTime(() => {
        this.$store.commit("app/set_video_dialog_isShow", true);
        this.$store.commit("app/set_video_data", this.sendData.fun.pop_video);
      });
    }
  },
  computed: {},
  components: {
    anchor_link,
    customer_service,
    file_download,
    phone_consultation,
    pop_video,
    site_link,
    submit_form
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.cover_anchor {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/set_link/index.vue